import React from "react";
import { Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

export const LargeDetailCard = (props) => {
  const sc = props.slice.primary;

  const data = props.slice.items;

  let space = sc.spacing;

  if (space === "Both large") {
    space = "gutter";
  } else if (space === "Both small") {
    space = "gutter sm";
  } else if (space === "Top large") {
    space = "gutter bot";
  } else if (space === "Top small") {
    space = "gutter bot sm";
  } else if (space === "Bottom large") {
    space = "gutter top";
  } else {
    space = "gutter top sm";
  }

  let bg;
  if (sc.background === "gradient") {
    bg = "gradient-to-b from-grey-light to-white";
  } else if (sc.background === "grey") {
    bg = "grey-light";
  } else {
    bg = sc.background;
  }


  return (
    <section className={"relative bg-" + bg + " " + space}>
      <div className="wrapper">
        <Link to={sc.link.url} className="lg-detail-card">
          <GatsbyImage className="w-full h-[16rem] md:h-auto md:w-1/3" image={getImage(sc.card_hero_image)} />
          <div className="p-7 md:p-16 w-full md:w-2/3">
            <img className="mb-8" src={sc.card_logo.url} />
            <h3 className="font-bold font-sans">{sc.card_title.text}</h3>
            <div className="relative flex gap-8 md:gap-20 my-8">
              {data.map((card, index) => {
                return (
                      <div key={index}>
                          <span className={"dta block text-" + (card.theme)}>{card.data_point.text}</span>
                          <span className="text-base text-grey">{card.data_description}</span>
                      </div>
                )
                })
              }
            </div>
            <div className="btn bg-yellow">{sc.button_label}</div>
          </div>
        </Link>
        
      </div>
    </section>
  );
};
